export default __webpack_public_path__ + "static/media/default-monochrome.65051e48.svg";